
import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackButton from "../../components/BackButton";
import { Container, Row, Col } from "react-bootstrap";
import "../../css/Filming.css";
import { useLocation } from "react-router-dom";

// Thay bằng đường dẫn JSON ảnh cưới truyền thống trên GitHub
const ALBUM_JSON_URL =
    "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/SanPhamQuayChup/HinhTT.json";

// Chuẩn hóa URL
const normalizeUrl = (url) => {
    if (typeof url !== "string") return "";

    const value = url.trim();

    if (!value) return "";

    return /^https?:\/\//i.test(value)
        ? value
        : `https://${value}`;
};

// Kiểm tra URL album
const isValidAlbumUrl = (url) => {
    try {
        const parsedUrl = new URL(url);

        return (
            parsedUrl.protocol === "https:" &&
            (
                parsedUrl.hostname === "photos.app.goo.gl" ||
                parsedUrl.hostname === "photos.google.com" ||
                parsedUrl.hostname === "drive.google.com" ||
                parsedUrl.hostname === "docs.google.com"
            )
        );
    } catch {
        return false;
    }
};

export default function AnhCuoiTruyenThong() {
    const location = useLocation();

    const [albums, setAlbums] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    // Cuộn lên đầu trang khi chuyển đường dẫn
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto",
        });
    }, [location.pathname]);

    // Tải danh sách album từ GitHub
    useEffect(() => {
        let isMounted = true;

        const fetchAlbums = async () => {
            try {
                setLoading(true);
                setError("");

                const response = await fetch(ALBUM_JSON_URL);

                if (!response.ok) {
                    throw new Error(
                        `Không thể tải JSON (HTTP ${response.status})`
                    );
                }

                const data = await response.json();

                if (!Array.isArray(data)) {
                    throw new Error(
                        "File JSON phải chứa một danh sách album."
                    );
                }

                const validAlbums = data
                    .filter(
                        (album) =>
                            album &&
                            typeof album.title === "string" &&
                            album.title.trim() !== "" &&
                            typeof album.url === "string"
                    )
                    .map((album) => ({
                        title: album.title.trim(),
                        url: normalizeUrl(album.url),
                    }))
                    .filter(
                        (album) =>
                            album.url && isValidAlbumUrl(album.url)
                    );

                if (isMounted) {
                    setAlbums(validAlbums);
                }
            } catch (err) {
                console.error("Lỗi tải album ảnh cưới truyền thống:", err);

                if (isMounted) {
                    setError(
                        "Không thể tải danh sách album. Vui lòng kiểm tra file JSON trên GitHub."
                    );
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchAlbums();

        return () => {
            isMounted = false;
        };
    }, []);

    // Chia thành từng hàng, tối đa 4 album mỗi hàng
    const albumRows = Array.from(
        { length: Math.ceil(albums.length / 4) },
        (_, index) => albums.slice(index * 4, index * 4 + 4)
    );

    return (
        <Container fluid>


            <Container className="album-list-page">
                {/* Nút quay lại */}
                <div className="page-back">
                    <BackButton fallback="/" />
                </div>

                {/* Tiêu đề */}
                <div className="album-page-title">
                    <h1>Ảnh Cưới Truyền Thống</h1>
                    <p>Chọn album bạn muốn xem</p>
                </div>

                {/* Đang tải */}
                {loading && (
                    <p className="album-message">
                        Đang tải danh sách album...
                    </p>
                )}

                {/* Lỗi tải dữ liệu */}
                {!loading && error && (
                    <p className="album-error">
                        {error}
                    </p>
                )}

                {/* Chưa có album */}
                {!loading && !error && albums.length === 0 && (
                    <p className="album-message">
                        Hiện chưa có album nào.
                    </p>
                )}

                {/* Tạo nút tự động từ JSON */}
                {!loading &&
                    !error &&
                    albumRows.map((rowAlbums, rowIndex) => (
                        <Row
                            className="service-filming-inform"
                            key={rowIndex}
                        >
                            {rowAlbums.map((album, index) => (
                                <Col
                                    xs={6}
                                    sm={3}
                                    key={`${album.title}-${index}`}
                                >
                                    <a
                                        className="NavLink"
                                        href={album.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {album.title}
                                    </a>
                                </Col>
                            ))}
                        </Row>
                    ))}
            </Container>

            <Footer />
        </Container>
    );
}
